// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/title/title.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-screen {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #0d0d0d;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    overflow: hidden;
    position: relative;
}

.title-screen-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.7);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    z-index: 10;
}

.logo-big {
    width: 400px;
    margin-bottom: 20px;
}

#firebaseui-auth-container {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/routes/TitleScreen.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yDAAgD;IAChD,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".title-screen {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #0d0d0d;\n    background-image: url('/public/title/title.png');\n    background-size: cover;\n    background-position: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.title-screen-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 40px;\n    border-radius: 10px;\n    background-color: rgba(0, 0, 0, 0.7);\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n    z-index: 10;\n}\n\n.logo-big {\n    width: 400px;\n    margin-bottom: 20px;\n}\n\n#firebaseui-auth-container {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
